import { render, staticRenderFns } from "./ModattaCompaniesLandingHowItWorks.vue?vue&type=template&id=3921c67c"
import script from "./ModattaCompaniesLandingHowItWorks.vue?vue&type=script&lang=js"
export * from "./ModattaCompaniesLandingHowItWorks.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports